import React, { useState} from "react"
import Alert from "@amzn/meridian/alert";
import Toaster from "@amzn/meridian/toaster";

/**
 * This component will render App notification messages
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AppNotification = (props) => {
    let alertType = props.type ? props.type : "informational";

    const [toasts] = useState(props.message ? [{
        id: Date.now().toString()
    }] : []);

    const onCloseToast = props.onClose

    return (
        <React.Fragment>
            <Toaster toasts={toasts} onCloseToast={onCloseToast}>
                {toast => <Alert type={alertType} toast={true} onClose={toast.onClose}>{props.message}</Alert>}
            </Toaster>
        </React.Fragment>
    )
}

export default AppNotification;


// WEBPACK FOOTER //
// ./src/components/eWayBill/constants/AppNotification.js